import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as DeleteIcon } from '@assets/svg/manage-multiplication-factors/ic-delete.svg';
import { ReactComponent as EditIcon } from '@assets/svg/manage-multiplication-factors/ic-edit.svg';
import { ReactComponent as ManageIcon } from '@assets/svg/manage-multiplication-factors/ic-manage.svg';

import { MODAL_NAMES } from '@constants/modalRenderers';

import useTranslation from '@hooks/useTranslation';

import type { ITemplateCurrenciesList } from '@pages/MultiplicationFactors/model/templateCurrenciesList';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

interface IProps {
  id: string;
  currencies: ITemplateCurrenciesList[];
}

const ContextMenu: React.FC<IProps> = ({ id, currencies }) => {
  const { t } = useTranslation();

  const { customerId } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const { setActiveModal } = useModalActions();

  return (
    <Tooltip
      id={id}
      place="left"
      openOnClick
      className={style.contextMenuPopover}
      clickable
      disableStyleInjection
      render={({ content }) => {
        if (!content) {
          return null;
        }
        const row = JSON.parse(content);

        return (
          <>
            <div
              className={style.contextMenuPopoverItem}
              onClick={() =>
                navigate(`/customer/${customerId}/multiplication-factors/manage-template/${row.id}`, {
                  state: { prevPage: pathname },
                })
              }
            >
              <ManageIcon className={style.menuIcon} />
              {t('Manage')}
            </div>
            <div
              className={style.contextMenuPopoverItem}
              onClick={() =>
                setActiveModal({
                  name: MODAL_NAMES.costSavingTemplateModal,
                  options: {
                    currentTemplate: row,
                    currencies,
                  },
                })
              }
            >
              <EditIcon className={style.menuIcon} />
              {t('Edit')}
            </div>
            <div
              className={style.contextMenuPopoverItem}
              onClick={() =>
                setActiveModal({
                  name: MODAL_NAMES.templateDeleteModal,
                  options: { currentTemplate: row },
                })
              }
            >
              <DeleteIcon className={style.menuIcon} />
              {t('Delete')}
            </div>
          </>
        );
      }}
    />
  );
};

export default ContextMenu;
